/* eslint-disable */
// 🤖 AUTO-GENERATED from data/components.json
// DO NOT EDIT MANUALLY - Changes will be overwritten
// Schema version: 1.0.0

/**
 * Unified mapping from full names to short names
 * Used for props and style properties
 */
export const NAME_TO_SHORT: Record<string, string> = {
  absolutePosition: 'ap',
  alignment: 'al',
  aspectRatio: 'ar',
  autoHideOnEnd: 'ahe',
  background: 'bkg',
  backgroundColor: 'bg',
  backgroundStyle: 'bgs',
  border: 'bd',
  borderColor: 'bc',
  borderRadius: 'br',
  borderWidth: 'bw',
  bottom: 'b',
  buttonStyle: 'bs',
  clipped: 'clip',
  color: 'c',
  colors: 'cls',
  cornerRadius: 'cr',
  countDown: 'cd',
  currentValueLabel: 'cvl',
  defaultValue: 'dv',
  direction: 'dir',
  dither: 'dth',
  durationMs: 'dur',
  endAtMs: 'end',
  endPoint: 'ep',
  fixedSizeHorizontal: 'fsh',
  fixedSizeVertical: 'fsv',
  flex: 'fl',
  flexGrow: 'fg',
  flexGrowWidth: 'fgw',
  font: 'fnt',
  fontSize: 'fs',
  fontVariant: 'fvar',
  fontWeight: 'fw',
  foregroundStyle: 'fgs',
  frame: 'f',
  gaugeStyle: 'gs',
  glassEffect: 'ge',
  height: 'h',
  italic: 'it',
  kerning: 'kern',
  label: 'lbl',
  layoutPriority: 'lp',
  left: 'l',
  letterSpacing: 'ls',
  lineHeight: 'lh',
  lineLimit: 'll',
  lineSpacing: 'lsp',
  lineWidth: 'lw',
  margin: 'm',
  marginBottom: 'mb',
  marginHorizontal: 'mh',
  marginLeft: 'ml',
  marginRight: 'mr',
  marginTop: 'mt',
  marginVertical: 'mv',
  maskElement: 'me',
  maxHeight: 'maxh',
  maximumValue: 'max',
  maximumValueLabel: 'maxl',
  maxWidth: 'maxw',
  minHeight: 'minh',
  minimumValue: 'min',
  minimumValueLabel: 'minvl',
  minLength: 'minl',
  minWidth: 'minw',
  monospacedDigit: 'md',
  multilineTextAlignment: 'mta',
  name: 'n',
  numberOfLines: 'nol',
  offset: 'off',
  offsetX: 'ox',
  offsetY: 'oy',
  opacity: 'op',
  overflow: 'ov',
  padding: 'pad',
  paddingBottom: 'pb',
  paddingHorizontal: 'ph',
  paddingLeft: 'pl',
  paddingRight: 'pr',
  paddingTop: 'pt',
  paddingVertical: 'pv',
  position: 'pos',
  progressColor: 'pc',
  resizeMode: 'rm',
  right: 'r',
  rotationEffect: 're',
  scale: 'sc',
  scaleEffect: 'sce',
  shadow: 'sh',
  shadowColor: 'shc',
  shadowOffset: 'sho',
  shadowOpacity: 'shop',
  shadowRadius: 'shr',
  size: 'sz',
  smallCaps: 'smc',
  source: 'src',
  spacing: 'sp',
  startAtMs: 'start',
  startPoint: 'stp',
  stops: 'sts',
  strikethrough: 'st',
  style: 's',
  systemImage: 'si',
  textAlign: 'ta',
  textDecorationLine: 'tdl',
  textStyle: 'ts',
  textTemplates: 'tt',
  thumb: 'th',
  tint: 'tnt',
  tintColor: 'tc',
  title: 'ttl',
  top: 't',
  trackColor: 'trc',
  transform: 'tf',
  type: 'typ',
  underline: 'ul',
  value: 'v',
  weight: 'wt',
  width: 'w',
  zIndex: 'zi',
}

/**
 * Reverse mapping from short names to full names
 */
export const SHORT_TO_NAME: Record<string, string> = {
  ap: 'absolutePosition',
  al: 'alignment',
  ar: 'aspectRatio',
  ahe: 'autoHideOnEnd',
  bkg: 'background',
  bg: 'backgroundColor',
  bgs: 'backgroundStyle',
  bd: 'border',
  bc: 'borderColor',
  br: 'borderRadius',
  bw: 'borderWidth',
  b: 'bottom',
  bs: 'buttonStyle',
  clip: 'clipped',
  c: 'color',
  cls: 'colors',
  cr: 'cornerRadius',
  cd: 'countDown',
  cvl: 'currentValueLabel',
  dv: 'defaultValue',
  dir: 'direction',
  dth: 'dither',
  dur: 'durationMs',
  end: 'endAtMs',
  ep: 'endPoint',
  fsh: 'fixedSizeHorizontal',
  fsv: 'fixedSizeVertical',
  fl: 'flex',
  fg: 'flexGrow',
  fgw: 'flexGrowWidth',
  fnt: 'font',
  fs: 'fontSize',
  fvar: 'fontVariant',
  fw: 'fontWeight',
  fgs: 'foregroundStyle',
  f: 'frame',
  gs: 'gaugeStyle',
  ge: 'glassEffect',
  h: 'height',
  it: 'italic',
  kern: 'kerning',
  lbl: 'label',
  lp: 'layoutPriority',
  l: 'left',
  ls: 'letterSpacing',
  lh: 'lineHeight',
  ll: 'lineLimit',
  lsp: 'lineSpacing',
  lw: 'lineWidth',
  m: 'margin',
  mb: 'marginBottom',
  mh: 'marginHorizontal',
  ml: 'marginLeft',
  mr: 'marginRight',
  mt: 'marginTop',
  mv: 'marginVertical',
  me: 'maskElement',
  maxh: 'maxHeight',
  max: 'maximumValue',
  maxl: 'maximumValueLabel',
  maxw: 'maxWidth',
  minh: 'minHeight',
  min: 'minimumValue',
  minvl: 'minimumValueLabel',
  minl: 'minLength',
  minw: 'minWidth',
  md: 'monospacedDigit',
  mta: 'multilineTextAlignment',
  n: 'name',
  nol: 'numberOfLines',
  off: 'offset',
  ox: 'offsetX',
  oy: 'offsetY',
  op: 'opacity',
  ov: 'overflow',
  pad: 'padding',
  pb: 'paddingBottom',
  ph: 'paddingHorizontal',
  pl: 'paddingLeft',
  pr: 'paddingRight',
  pt: 'paddingTop',
  pv: 'paddingVertical',
  pos: 'position',
  pc: 'progressColor',
  rm: 'resizeMode',
  r: 'right',
  re: 'rotationEffect',
  sc: 'scale',
  sce: 'scaleEffect',
  sh: 'shadow',
  shc: 'shadowColor',
  sho: 'shadowOffset',
  shop: 'shadowOpacity',
  shr: 'shadowRadius',
  sz: 'size',
  smc: 'smallCaps',
  src: 'source',
  sp: 'spacing',
  start: 'startAtMs',
  stp: 'startPoint',
  sts: 'stops',
  st: 'strikethrough',
  s: 'style',
  si: 'systemImage',
  ta: 'textAlign',
  tdl: 'textDecorationLine',
  ts: 'textStyle',
  tt: 'textTemplates',
  th: 'thumb',
  tnt: 'tint',
  tc: 'tintColor',
  ttl: 'title',
  t: 'top',
  trc: 'trackColor',
  tf: 'transform',
  typ: 'type',
  ul: 'underline',
  v: 'value',
  wt: 'weight',
  w: 'width',
  zi: 'zIndex',
}

/**
 * Shorten a name using the unified mapping
 * Returns the original name if no short form exists
 */
export function shorten(name: string): string {
  return NAME_TO_SHORT[name] ?? name
}

/**
 * Expand a short name back to the full name
 * Returns the original value if no expansion exists
 */
export function expand(short: string): string {
  return SHORT_TO_NAME[short] ?? short
}
